import { FC, useState } from 'react';
import { IGroupedRole, IRoleGoup } from '../../model/IRole';
import TextButtom from '../common/buttom/TextButtom';
import { icons } from '../../icons/IconSet';
import { useRole } from '../../hooks/useRole';
import { useConfirm } from '../../hooks/useConfirm';
import { useAccess } from '../../hooks/useAccess';
import toast from 'react-hot-toast';
import { msg } from '../../msg';
import EditRoleForm from './EditRoleForm';
import { ITicketType } from '../../model/ITicketType';

const RoleFormItem: FC<{ role: IGroupedRole, roleGroup: IRoleGoup }> = ({ role, roleGroup }) => {
  const { deleteRole, editRole } = useRole(roleGroup);
  const { getSettingAccess } = useAccess();
  const confirm = useConfirm();

  const [isModal, setIsModal] = useState<boolean>(false);
  const [isPending, setIsPending] = useState<boolean>(false);

  const handleDeleteRole = async () => confirm.on({
    text: <>Please confirm that you want to delete this role <b>{role.id}</b> from group <b>{roleGroup.capitalize()}</b></>,
    action: async () => {
      setIsPending(() => true);
      const response = await deleteRole(role.id);
      if (!response) toast.success(msg('role-deleted', { id: role.id }));
      else if (response?.totalError) toast.error(response?.totalError);
      setIsPending(() => false);
    },
    applyText: 'Delete',
    applyButtonType: 'delete'
  });

  return (
    <div className={`flex items-center bg-slate-100 [&_span]:opacity-20 rounded-xl shadow-sm border-[1px]
     hover:bg-white [&:hover_span]:opacity-100 hover:shadow-lg transition-all
     ${isPending ? ' animate-pulse' : ''}
    `}>
      <div className="flex flex-col px-4 py-2">
        <div className="flex items-center gap-3">

          <div className="text-md cursor-default">
            {role.name} (#{role.id})
          </div>

          <div className="flex gap-2">

            {!!getSettingAccess('delete-role') && (
              <span>
                <TextButtom
                  type="delete"
                  onClick={handleDeleteRole}
                  desabled={isPending}
                >
                  {icons('trash-2', { width: '1.2em' })}
                </TextButtom>
              </span>
            )}

            {!!getSettingAccess('edit-role') && (
              <>
                <span>
                  <TextButtom onClick={() => setIsModal(() => true)}>
                    {icons('settings', { width: '1.2em' })}
                  </TextButtom>
                </span>
                <EditRoleForm
                  isModal={isModal}
                  setIsModal={setIsModal}
                  title={`Edit role ${role.id} in ${roleGroup.capitalize()} group`}
                  editRole={editRole}
                  initNewRoleForm={{
                    ...role,
                    systemRole: "agent",
                    description: role.description || '',
                    ticketTypes: role.ticketTypes.map(({ id }) => id).join(",")
                  }}
                />
              </>
            )}

          </div>
        </div>

        {!!role.description && (
          <div className="text-slate-500">
            {role.description}
          </div>
        )}

      </div>
    </div>
  );
}

export default RoleFormItem;
